import type { SparklineProps } from "./contract";
import styles from "./Sparkline.module.css";

// 값 몇십 개의 모양을 한 줄 높이로 보여 주는 막대 줄이다. 축과 눈금이 없다. 그래서 크기는 읽을 수
// 없고 모양(언제 많았는가)만 읽는다. 크기는 옆의 숫자가 말한다.
//
// 높이는 이 줄의 최댓값을 기준으로 맞춘다. 그래서 서로 다른 줄의 막대 높이는 비교할 수 없다.
// 0 은 막대를 그리지 않고 바닥선만 남긴다. 낮은 값과 0 이 같아 보이지 않게 한다.
export function Sparkline({ values, ariaLabel }: SparklineProps) {
  const max = values.reduce((highest, value) => Math.max(highest, value), 0);
  return (
    <span className={styles.track} role="img" aria-label={ariaLabel}>
      {values.map((value, position) => (
        <span
          // 값의 순서가 곧 자리다. 값이 같은 칸이 여럿이라 값으로는 key 를 만들 수 없다.
          key={position}
          className={value > 0 ? styles.bar : styles.empty}
          style={value > 0 ? { height: `${barHeightPercent(value, max)}%` } : undefined}
        />
      ))}
    </span>
  );
}

// 0 이 아닌 값은 최소 높이를 가진다. 최댓값의 1% 인 날도 "사용이 있었다"로 보여야 한다.
const minBarHeightPercent = 8;

function barHeightPercent(value: number, max: number): number {
  return Math.max(minBarHeightPercent, Math.round((value / max) * 100));
}
